module.exports = __webpack_public_path__ + "img/mg.fa519daf.jpg";